import { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas'
import { useNavigate } from 'react-router-dom';

import "./Signature.scss"
const Signature = () => {

    const sigCanvas = useRef({})

    const navigate = useNavigate();

    const [isEmployerSignature, setIsEmployerSignature] = useState(false)
    // const [technicianSignature, setTechnicianSignature] = useState(false)

    const save = async () => {

        if (isEmployerSignature === false) {
            setIsEmployerSignature(true)
            await sessionStorage.setItem('employer-signuture', sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"))
            await clear();
        } else if (isEmployerSignature === true) {
            await sessionStorage.setItem('technician-signuture', sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"))
            navigate("/projects/project-review");

        }
    }

    const clear = () => {
        sigCanvas.current.clear();
    }

    return (
        <div className="main-container d-flex flex-column page-content-center">
            {
                isEmployerSignature ?
                    <h3>
                        امضا سرپرست:
                    </h3> :
                    <h3>
                        امضا کارفرما:
                    </h3>
            }
            <SignatureCanvas penColor='black'
                canvasProps={{ className: 'signature-canvas' }}
                ref={sigCanvas} />
            <div className="button-container">

                <button className="w-90 custom-button-blue"
                    // variant='contained'
                    onClick={save}>
                    ذخیره امضا
                </button>
                <button className="w-90 custom-button-danger"
                    // variant='outlined'                    color='error'

                    onClick={clear}>
                    پاک کردن
                </button>
            </div>
        </div>
    )
}

export default Signature
